import apiClient from '../client';

export interface VehicleSalesRow {
  MakeId: number;
  Make: string;
  ModelId: number;
  Model: string;
  UnitsSold: number;
  OrderCount: number;
  Revenue: number;
}

export interface SalesDiagnostics {
  OrderCount: number;
  ItemCount: number;
  PartAppCount: number;
  ExactMatchCount: number;
  SampleOrderPartNumbers: string;
  SamplePartAppNumbers: string;
}

export interface MaterialTrimRow {
  Material: string;
  TrimCode: string;
  UnitsSold: number;
  OrderCount: number;
  Revenue: number;
}

export interface SalesByVehicleResult {
  vehicles: VehicleSalesRow[];
  totalUnitsSold: number;
  totalRevenue: number;
}

export const salesByVehicleService = {
  async getSalesByVehicle(dateFrom: string, dateTo: string): Promise<SalesByVehicleResult> {
    const response = await apiClient.get<SalesByVehicleResult>('/sales-by-vehicle', {
      params: { dateFrom, dateTo },
    });
    return response.data;
  },

  async getMaterialBreakdown(
    makeId: number,
    modelId: number,
    dateFrom: string,
    dateTo: string,
  ): Promise<MaterialTrimRow[]> {
    const response = await apiClient.get<MaterialTrimRow[]>('/sales-by-vehicle/breakdown', {
      params: { makeId, modelId, dateFrom, dateTo },
    });
    return response.data;
  },

  async getDiagnostics(dateFrom: string, dateTo: string): Promise<SalesDiagnostics> {
    const response = await apiClient.get<SalesDiagnostics>('/sales-by-vehicle/diagnostics', {
      params: { dateFrom, dateTo },
    });
    return response.data;
  },
};
